import { render, staticRenderFns } from "./notPay.vue?vue&type=template&id=3bb1af84&scoped=true"
import script from "./notPay.vue?vue&type=script&lang=js"
export * from "./notPay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb1af84",
  null
  
)

export default component.exports